module.exports = __webpack_public_path__ + "files/piccmid.7cd18638de1f927667bb7945eb9f3e73.pdf";